/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
// material
import { styled } from '@mui/material/styles';
import { Card, CardContent, Grid, Typography } from "@mui/material";

const ContainerStyle = styled(Grid)(() => ({
    margin: '5px 0',
}));

const Label = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[600],
    marginRight: 5,
}));

const Validation = styled(Typography)(({ theme, state }) => ({
    color: state === '1' ? theme.palette.success.main : state === '2' ? theme.palette.info.main : theme.palette.error.main,
}));

const getConformityLabel = (conformityId, t) => {
    if (conformityId === 1) {
        return t('inspections.info-card.complaint');
    }
    if (conformityId === 2) {
        return t('inspections.items.scheduled');
    }
    return t('inspections.info-card.non-complaint');
};

const getUserName = (data) => {
    const isScheduled = data?.conformity?.id === 2;
    if (isScheduled && data?.assignedToUser) {
        return `${data.assignedToUser.firstName || ''} ${data.assignedToUser.lastName || ''}`.trim() || '-';
    }
    if (data?.submittedByUser) {
        return `${data.submittedByUser.firstName || ''} ${data.submittedByUser.lastName || ''}`.trim() || '-';
    }
    return data?.employee || '-';
};

InfoCard.propTypes = {
    t: PropTypes.func,
    data: PropTypes.object,
}

export default function InfoCard({ t, data }) {
    return (
        <Card>
            <CardContent>
                <Grid container spacing={5}>
                    <Grid item>
                        <ContainerStyle container direction="row">
                            <Label>
                                {`${t('inspections.items.date')}:`}
                            </Label>
                            <Typography>
                                {data?.controlDate}
                            </Typography>
                        </ContainerStyle>
                        <ContainerStyle container direction="row">
                            <Label>
                                {`${t('inspections.info-card.employee')}:`}
                            </Label>
                            <Typography>
                                {getUserName(data)}
                            </Typography>
                        </ContainerStyle>
                        <ContainerStyle container direction="row">
                            <Label>
                                {`${t('inspections.info-card.state')}:`}
                            </Label>
                            <Validation state={data?.conformity?.id?.toString()}>
                                {getConformityLabel(data?.conformity?.id, t)}
                            </Validation>
                        </ContainerStyle>
                    </Grid>
                    <Grid item>
                        <ContainerStyle container direction="row">
                            <Label>
                                {`${t('inspections.items.resource')}:`}
                            </Label>
                            <Typography>
                                {data?.resource?.name}
                            </Typography>
                        </ContainerStyle>
                        <ContainerStyle container direction="row">
                            <Label>
                                {`${t('inspections.items.resource-type')}:`}
                            </Label>
                            <Typography>
                                {data?.resource?.resourceType?.name}
                            </Typography>
                        </ContainerStyle>
                        <ContainerStyle container direction="row">
                            <Label>
                                {`${t('inspections.items.flow-type')}:`}
                            </Label>
                            <Typography>
                                {data?.flow?.name}
                            </Typography>
                        </ContainerStyle>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
